<template>
  <UlDialog
    v-model="dialog"
    header-type="information"
    :persistent="deleted"
    :left-header-icon="`icons/${deleted ? 'check_circle' : 'stop'}.svg`"
    :title="dialogTitle"
    :buttons="accountDeleteButtons"
    @input="handleDialogInput"
  >
    <template #text>
      <AccountDelete />
    </template>
  </UlDialog>
</template>

<script>
import accountDelete from '@/mixins/accountDelete';

export default {
  name: 'AccountDeleteDialog',
  mixins: [accountDelete],
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'accountDelete';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    dialogTitle() {
      if (this.deleted) {
        return this.$t('profile.removeDialog.confirmTitle');
      }

      switch (this.step) {
        case 3:
          return this.$t('profile.removeDialog.feedback.title');
        default:
          return this.$t('profile.removeDialog.title');
      }
    }
  },
  methods: {
    handleDialogInput(value) {
      if (!value) {
        this.closeAccountDeleteDialog();
      }
    }
  }
};
</script>
